/* eslint-disable react/no-find-dom-node */
import React, { Component } from 'react'
import PropTypes from "prop-types";
import { Select, Popover } from '@tinper/next-ui'
import ClassNames from 'classnames';
import { ConfigConsumer } from "./config-provider/context";
import LocaleReceiver from "./locale-provider/localeReciever";
import Table from '../../DataTable/src'
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep'
// import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import get from 'lodash/get'
import zhcn from "./locale/zh_CN";
import './index.less'

const propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  labelValue: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  onChange: PropTypes.func,
  columns: PropTypes.array,
  rowKey: PropTypes.string,
  labelKey: PropTypes.string,
  disabled: PropTypes.bool,
  dataSource: PropTypes.array,
  filterKey: PropTypes.string,
  tableWidth: PropTypes.number,
  showHeader: PropTypes.bool, // 是否显示表头
  multiple: PropTypes.bool, // 是否多选
  className: PropTypes.string,
  popoverClassName: PropTypes.string,
  placeholder: PropTypes.string,
  allowClear: PropTypes.bool,
  maxTagCount: PropTypes.number,
  maxTagTextLength: PropTypes.number
}

const defaultProps = {
  multiple: false,
  allowClear: true,
  disabled: false
}
class InputSelect extends Component {
  constructor (props) {
    super();
    this.selectRef = React.createRef()
    this.tableRef = React.createRef()
    this.isCompositionStart = false // 设为true时就是在用拼音拼写的时候
    this.clickPopoverStatus = false // 如果popover被点击了，设为true，input或者select失焦时，要看看是否是点击的面板，如果是点击的面板，那么不隐藏popover
    this.focusStatus = false // 标识是否input或select获得焦点
    this.focusTime = 0 // 获取focus的时间，用来判断input输入框是不是点击的clear，focus后短时间onchange则为clear
    this.reload = false // 是否重新加载表格，当输入无效的搜索词之后，设为true，下次重新请求
    this.init = false

    console.log('typeof props.value', typeof props.value)
    this.state = {
      tableWidth: props.tableWidth,
      keywords: '', // 搜索关键词
      inputValue: typeof props.labelValue === 'undefined' ? props.value : props.labelValue,
      selectedRowKeys: !props.value ? [] : props.value.split(','),
      selectedRowLabels: typeof props.labelValue === 'undefined' ? (!props.value ? [] : props.value.split(',')) : props.labelValue.split(',') || [],
      showPopover: false
    }
  }

  componentDidMount () {
    if (!this.props.tableWidth) {
      this.getWidth()
    }
    this.throttleRefreshTable = debounce(this.refreshTable, 1000)
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    const { selectedRowKeys } = this.state
    // const { multiple } = this.props
    const nextValue = typeof nextProps.value === 'undefined' ? [] : nextProps.value.split(',')
    if (nextProps.value !== this.props.value && nextValue.join(',') !== selectedRowKeys.join(',')) {
      const keys = typeof nextProps.value === 'undefined' ? [] : nextProps.value.split(',')
      const labels = typeof nextProps.labelValue === 'undefined' ? (typeof nextProps.value === 'undefined' ? [] : nextProps.value.split(',')) : nextProps.labelValue.split(',') || []
      this.setState({
        selectedRowKeys: keys,
        selectedRowLabels: labels
      })
    }

    // 搜索框输入检索，由用户更改数据
    // if (!this.isUndefined(nextProps.dataSource) && !this.isUndefined(this.props.dataSource) && nextProps.dataSource.length !== this.props.dataSource.length) {
    //   if (this.state.showPopover) {
    //     this.onSearch(this.state.keywords)
    //   }
    // }
  }

  isUndefined = (value) => {
    return typeof value === 'undefined';
  }

  getWidth = () => {
    this.setState({
      // tableWidth: (ReactDOM.findDOMNode(this.selectRef.current) && ReactDOM.findDOMNode(this.selectRef.current).offsetWidth) || 100
      tableWidth: this.selectRef.current.getSelectDOMNode().offsetWidth || 100
    })
  }

  onVisibleChange = (visible) => {
    console.log('visible', visible)

    if (!visible) {
      clearTimeout(this.onBlurTimer)
      this.onBlurTimer = setTimeout(() => {
        if (!this.clickPopoverStatus && !this.focusStatus) {
          this.setState({
            showPopover: false
          })
        }
      }, 200)
    }
  }

  // filterDataSource = (keywords) => {
  //   const { filterKey } = this.props;
  //   if (filterKey) {

  //   }
  // }

  onSearch = (keywords) => {
    console.log('onSearch', keywords, Date.now())
    const { onSearch } = this.props

    clearTimeout(this.onSearchTimer)
    this.onSearchTimer = setTimeout(() => {
      if (!this.clickPopoverStatus) {
        this.setState({
          keywords
        }, () => {
          this.tableRef.current && this.tableRef.current.reload()
          onSearch && onSearch(keywords)
        })
      }
    }, 200)
  }

  onFocus = () => {
    console.log('onFocus')
    const { onSearch } = this.props

    this.clickPopoverStatus = false
    this.focusStatus = true
    this.focusTime = new Date().getTime()
    console.log(this.init, 'init')
    if (this.init && this.reload) {
      this.setState({
        keywords: ''
      }, () => {
        this.tableRef.current.reload()
        onSearch && onSearch('')
      })
    }
    this.init = true
    this.timerOfShowPopover = setTimeout(() => {
      this.setState({
        showPopover: true
      })
    }, 200)
  }

  onBlur = () => {
    const { multiple } = this.props
    // const { selectedRowKeys, selectedRowLabels, inputValue } = this.state
    const { selectedRowLabels, inputValue } = this.state
    this.focusStatus = false
    clearTimeout(this.onBlurTimer)
    this.onBlurTimer = setTimeout(() => {
      if (!this.clickPopoverStatus) {
        this.setState({
          showPopover: false
        })

        if (!multiple && (inputValue !== selectedRowLabels[0])) {
          this.setState({
            inputValue: selectedRowLabels[0] || ''
          })
          this.reload = true
        } else {
          this.reload = false
        }
        console.log(this.reload, "reload");
      }
    }, 200)
  }

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.reload()
  }

  onTableClick = (e) => {
    this.clickPopoverStatus = true
    clearTimeout(this.onRowSelectTimer)
    this.onRowSelectTimer = setTimeout(() => {
      this.clickPopoverStatus = false
    }, 300)
  }

  onClear = () => {
    const { onChange } = this.props
    this.setState({
      selectedRowKeys: [],
      selectedRowLabels: []
    }, () => {
      this.tableRef && this.tableRef.current && this.tableRef.current.reload()
      console.log('onChange', '', [])
      onChange && onChange('', [])
    })
  }

  onDeselect = (value) => {
    const { onChange } = this.props
    const { selectedRowKeys, selectedRowLabels } = this.state
    const selectedKeys = cloneDeep(selectedRowKeys)
    const selectedLabels = cloneDeep(selectedRowLabels)

    let index
    for (let i = 0; i < selectedRowLabels.length; i++) {
      if (selectedRowLabels[i] === value) {
        index = i
        break
      }
    }
    selectedKeys.splice(index, 1)
    selectedLabels.splice(index, 1)

    this.setState({
      selectedRowKeys: selectedKeys,
      selectedRowLabels: selectedLabels
    }, () => {
      console.log('onChange', selectedKeys.join(','), this.mergeKeyAndLabel(selectedKeys, selectedLabels))
      onChange && onChange(selectedKeys.join(','), this.mergeKeyAndLabel(selectedKeys, selectedLabels))
    })
  }

  onRowEvent = (record) => {
    return {
      onClick: event => {
        const { multiple, rowKey, labelKey, onChange } = this.props
        const { selectedRowKeys, selectedRowLabels } = this.state
        let selectedKeys = cloneDeep(selectedRowKeys)
        let selectedLabels = cloneDeep(selectedRowLabels)

        const key = get(record, rowKey)
        const label = get(record, labelKey || rowKey)

        if (!selectedRowKeys.includes(key)) {
          if (multiple) {
            selectedKeys.push(key)
            selectedLabels.push(label)
          } else {
            selectedKeys = [key]
            selectedLabels = [label]
          }
        } else {
          if (multiple) {
            let index
            for (let i = 0; i < selectedKeys.length; i++) {
              if (selectedKeys[i] === key) {
                index = i
                break
              }
            }
            selectedKeys.splice(index, 1)
            selectedLabels.splice(index, 1)
          } else {
            // 单选不允许取消
          }
        }
        this.setState({
          selectedRowKeys: selectedKeys,
          selectedRowLabels: selectedLabels
        }, () => {
          console.log('onChange', selectedKeys.join(','), this.mergeKeyAndLabel(selectedKeys, selectedLabels), record)
          onChange && onChange(selectedKeys.join(','), this.mergeKeyAndLabel(selectedKeys, selectedLabels), record)
        })
        if (!multiple) {
          this.setState({
            inputValue: selectedLabels[0],
            showPopover: false
          })
        }
      }
    }
  }

  mergeKeyAndLabel = (selectedRowKeys, selectedRowLabels) => {
    const result = []
    for (let i = 0; i < selectedRowKeys.length; i++) {
      result.push({
        value: selectedRowKeys[i],
        label: selectedRowLabels[i]
      })
    }
    return result
  }

  rowClassName = (record, index) => {
    // const { multiple, rowKey } = this.props
    const { rowKey } = this.props
    const { selectedRowKeys } = this.state
    const getPrefixCls = this.getPrefixCls
    const key = get(record, rowKey)
    if (selectedRowKeys.includes(key)) {
      return ClassNames(`${getPrefixCls('input-select-table-row-active')}`)
    }
  }

  reloadTable = () => {
    this.tableRef.current.reload()
  }
  // onInputComposition = (e) => {//输入拼音触发
  //     // console.log(e.type,'type')
  //     if(e.type === 'compositionstart') {
  //         this.isCompositionStart = true;
  //     }else if(e.type === 'compositionend'){
  //         this.isCompositionStart = false;
  //         this.tableRef.current && this.tableRef.current.reload()
  //     }

  // }
  // onInputCompositionStart = (e) => {
  //   this.isCompositionStart = true;
  // }

  // onInputCompositionEnd = (e) => {
  //   const { onSearch } = this.props
  //   this.isCompositionStart = false;
  //   this.tableRef.current && this.tableRef.current.reload()
  //   onSearch && onSearch(e.target.value)
  // }

  renderInputSelect = (props, locale) => {
    const { className, style, popoverClassName, dataSource, columns, multiple, rowKey, showHeader, placeholder, allowClear, maxTagCount, maxTagTextLength, getPopupContainer, disabled } = this.props
    const { tableWidth, selectedRowLabels } = this.state
    this.getPrefixCls = props.getPrefixCls

    const getContainer = getPopupContainer || function () { return document.body };

    const classPropOfPopover = ClassNames(`${props.getPrefixCls('input-select-popover')}`, popoverClassName)
    const classPropOfSelect = ClassNames(`${props.getPrefixCls('input-select-select')}`, className)

    const tableOpts = omit(this.props, [
      "value",
      "onChange",
      "columns",
      "rowKey",
      "dataSource",
      "tableWidth",
      "showHeader",
      "multiple",
      "className",
      "popoverClassName",
      "placeholder",
      "allowClear"
    ]);
    return (
      <Popover
        overlayClassName={classPropOfPopover}
        overlayStyle={{ width: `${tableWidth}px` }}
        placement={'bottomLeft'}
        autoAdjustOverflow={false}
        trigger="click"
        // visible={true}
        onVisibleChange={this.onVisibleChange}
        getPopupContainer={getContainer}
        content={(
          <div onClick={this.onTableClick}>
            <Table
              showModeSwitch={false}
              {...tableOpts}
              ref={this.tableRef}
              columns={columns}
              //   pagePositionFixed={false}
              pagination={{ simple: true }}
              rowKey={rowKey}
              data={dataSource}
              fillSpace={false}
              showHeader={typeof showHeader === 'undefined' ? columns.length > 1 : showHeader}
              rowClassName={this.rowClassName}
              onRow={this.onRowEvent}

            />
          </div>

        )}>

        {
          <Select
            style={style}
            className={classPropOfSelect}
            ref={this.selectRef}
            autoClearSearchValue={true}
            value={selectedRowLabels}
            mode={multiple ? 'tags' : 'default'}
            disabled={disabled}
            maxTagCount={maxTagCount}
            maxTagTextLength={maxTagTextLength}
            showSearch={true}
            showArrow={false}
            onSearch={this.onSearch}
            onDeselect={this.onDeselect}
            onClear={this.onClear}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            open={false}
            placeholder={placeholder}
            allowClear={allowClear}></Select>
        }

      </Popover>
    )
  }

  render () {
    return <ConfigConsumer>
      {
        (configProps) => {
          return <LocaleReceiver componentName={'InputSelect'} defaultLocale={zhcn.InputSelect}>
            {
              (locale) => {
                return this.renderInputSelect(configProps, locale)
              }
            }
          </LocaleReceiver>
        }

      }
    </ConfigConsumer>
  }
}

InputSelect.defaultProps = defaultProps;
InputSelect.propTypes = propTypes;
export default InputSelect
